import { useMemo } from 'react';
import { useLocation } from 'react-router';
import { useApp } from '../../providers/AppProvider';
import useQueryParams from './useQueryParams';

const useBounceUrl = () => {
  const location = useLocation();
  const query = useQueryParams();
  const { isLoggedIn } = useApp();

  const authRedirect = useMemo(() => {
    const bounceUrl = query.get('bounceUrl');

    return bounceUrl && isLoggedIn
      ? decodeURIComponent(bounceUrl.replace(/[\\():+?*{}]/g, c => '\\' + c))
      : null;
  }, [isLoggedIn, query]);

  const bounceUrl = useMemo(() => {
    const bounceUrl = query.get('bounceUrl');

    if (!isLoggedIn && bounceUrl) {
      return `?bounceUrl=${encodeURIComponent(bounceUrl)}`;
    } else if (!isLoggedIn) {
      return location.pathname !== '/' && location.pathname !== '/logout'
        ? `?bounceUrl=${encodeURIComponent(`${location.pathname}${location.search}`)}`
        : null;
    } else {
      return null;
    }
  }, [query, isLoggedIn, location.pathname, location.search]);

  return { bounceUrl, authRedirect };
};

export default useBounceUrl;
